export default __webpack_public_path__ + "static/media/e&logo.bb88de23.svg";